import { render, staticRenderFns } from "./blockZkn.vue?vue&type=template&id=c8aaee7c&scoped=true&"
import script from "./blockZkn.vue?vue&type=script&lang=js&"
export * from "./blockZkn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aaee7c",
  null
  
)

export default component.exports